import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { BUSINESS_PATH, LAST_NAME_PATH } from "../../routing/paths";
import SimpleStep from "../SimpleStep";
import { notBlank } from "../../shared/validations";

const simpleStepProps = {
  previous: BUSINESS_PATH,
  next: LAST_NAME_PATH,
  question: "By the way, what's your",
  target: "first name",
  description: "This will help us treat your more personally.",
  spellName: "first_name",
  validation: notBlank,
};

export const FirstNameStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <SimpleStep wizard={props} {...simpleStepProps} />
);

export default WizardContainer(FirstNameStep);
